import React from 'react';

const WhyChooseUs = () => (
  <div className="container mx-auto px-4 py-8">
    <h1 className="text-3xl font-bold mb-6">Why Choose Us?</h1>

    <div className="mb-8 border-b border-gray-200 py-6">
      <h2 className="text-xl font-semibold mb-2">Hands-On and Proven Expertise</h2>
      <p className="mb-4">
        Unlike others who only advise or warn about future cryptographic risks, we are truly hands-on. We demonstrate our expertise by applying post-quantum cryptography (PQC) to our own website. This proves that we do not just talk about the latest security standards—we actively implement them in real-world environments. With us, you see concrete results, not just theoretical advice.
      </p>
    </div>

    <div className="mb-8 border-b border-gray-200 py-6">
      <h2 className="text-xl font-semibold mb-2">A Practical Approach for Existing and Cloud Infrastructures</h2>
      <p className="mb-4">
        We have developed a unique, practical method for implementing PQC within existing IT infrastructures—including environments where PQC is not supported out of the box, such as many cloud platforms. This means your organization does not need to wait for vendors or providers to act; we make you future-proof today.
      </p>
    </div>

    <div className="mb-8 border-b border-gray-200 py-6">
      <h2 className="text-xl font-semibold mb-2">Built-In Crypto Agility</h2>
      <p className="mb-4">
        Our approach ensures your organization is <strong><a href="https://en.wikipedia.org/wiki/Cryptographic_agility" target="_blank" rel="noopener noreferrer" className="text-blue-600">crypto agile</a></strong>. You will not be locked into a single cryptographic algorithm or solution. Instead, you will have the flexibility to seamlessly transition to stronger encryption as soon as new standards emerge or requirements change. This is essential for lasting, adaptable security.
      </p>
    </div>

    <div className="mb-8 border-b border-gray-200 py-6">
      <h2 className="text-xl font-semibold mb-2">Small Company, Low Overhead, Affordable Solutions</h2>
      <p className="mb-4">
        We are a small business with low overheads—no expensive offices or luxury cars. That enables us to offer expert services at rates suitable even for organizations with limited budgets, such as SMEs. We understand the needs of businesses (not only the big ones, also the small ones) and provide personal, effective solutions without unnecessary costs.
      </p>
    </div>

    <div className="bg-blue-100 p-6 rounded-lg mb-8">
      <p className="text-lg">
        Questions? Ready to begin? <a href="/contact-us" className="text-blue-600 hover:underline">Contact Us Here</a>
      </p>
      <p className="mt-4 font-semibold">
        Stay safe today. Stay safe tomorrow.
      </p>
    </div>
  </div>
);

export default WhyChooseUs;
